import { cn } from "@/lib/utils";
import { WidgetPanel } from "@/components/dashboard-grid/WidgetPanel";
import type { BdPayload } from "@shared/bdTracker";
import { nextWho } from "./format";

const num = "text-right tabular-nums px-2";

/** One row per team member. Clicking a row focuses the page on them; clicking it again returns to everyone. */
export function BdScoreboard({ data, onSelect, title }: { data: BdPayload; onSelect: (who: string) => void; title?: string }) {
  return (
    <WidgetPanel title={title ?? `Team · ${data.period.label}`} meta="click a person to focus the page">
      <table className="w-full text-xs">
        <thead className="sticky top-0 bg-card text-muted-foreground">
          <tr className="border-b border-border/60">
            <th scope="col" className="text-left font-medium px-3 py-1.5">Person</th>
            <th scope="col" className={`${num} font-medium`}>Touchpoints</th>
            <th scope="col" className={`${num} font-medium`}>Meetings</th>
            <th scope="col" className={`${num} font-medium`}>COIs added</th>
            <th scope="col" className={`${num} font-medium`}>Sourced</th>
            <th scope="col" className={`${num} font-medium pr-3`}>Referrals in</th>
          </tr>
        </thead>
        <tbody>
          {data.scoreboard.map((r) => {
            const on = r.person.id === data.who;
            const select = () => onSelect(nextWho(data.who, r.person.id));
            return (
              <tr key={r.person.id} onClick={select}
                className={cn("border-b border-border/40 cursor-pointer hover:bg-muted/40",
                  on && "bg-amber-50 dark:bg-amber-950/30")}>
                <td className="px-3 py-1.5 whitespace-nowrap">
                  <button type="button" aria-pressed={on} onClick={(e) => { e.stopPropagation(); select(); }}
                    className="font-medium hover:underline text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring rounded-sm">{r.person.name}</button>
                  {r.person.title && <span className="ml-1.5 text-[10px] px-1.5 py-0.5 rounded bg-muted text-muted-foreground">{r.person.title}</span>}
                </td>
                <td className={num}>{r.touchpoints}</td>
                <td className={num} title={r.meals ? `${r.meals} over a meal` : undefined}>{r.meals ? `${r.meetings} (${r.meals} meal)` : r.meetings}</td>
                <td className={num}>{r.coisAdded}</td>
                <td className={num}>{r.sourced}</td>
                <td className={`${num} pr-3`}>{r.referralsIn || "—"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </WidgetPanel>
  );
}
